
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VulvarCancer_FIGO',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/VulvarCancer_FIGO.vue